import React, { memo, ReactNode } from 'react';
import classNames from 'classnames';
import cls from './NotificationItem.module.css';
import { useNotificationItem } from './useNotificationItem';
import { Icon } from '../../components/newUI/Icon/Icon';
import { INotification, ModalSystemContent, NotificationType } from '../types/types';
import moment from 'moment';
import { EntityId } from '@reduxjs/toolkit';

interface NotificationItemProps {
    classes?: string;
    id: EntityId;
    onOpenModalSystem: (data: ModalSystemContent) => void;
    onClose: () => void;
}

export const NotificationItem = memo(
    ({ classes, id, onOpenModalSystem, onClose }: NotificationItemProps) => {
        const { currentNotification, onClickNotificationItem, onViewNotification } =
            useNotificationItem(id, onOpenModalSystem, onClose);

        if (!currentNotification) return null;

        return (
            <div
                className={classNames(
                    cls.NotificationItem,
                    {
                        [cls.notViewed]: !currentNotification.is_viewed,
                    },
                    [classes]
                )}
                data-id={id}
                onClick={onClickNotificationItem}
                onMouseEnter={() => onViewNotification(id)}
            >
                <div className={classNames(cls.icon)}>
                    <img src={currentNotification.image.url} alt={'logo'} />
                </div>
                <div className={cls.content}>
                    <div
                        className={cls.title}
                        dangerouslySetInnerHTML={{ __html: currentNotification.title }}
                    />
                    <div
                        className={cls.subtitle}
                        dangerouslySetInnerHTML={{ __html: currentNotification.text }}
                    />
                </div>
                <div className={cls.date}>
                    {moment(currentNotification.created_at).format('DD.MM.YYYY, HH:mm')}
                </div>
            </div>
        );
    }
);
